/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { vendorInquiryControllerAnswer } from '../fn/vendor-inquiry/vendor-inquiry-controller-answer';
import { VendorInquiryControllerAnswer$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-answer';
import { vendorInquiryControllerCreate } from '../fn/vendor-inquiry/vendor-inquiry-controller-create';
import { VendorInquiryControllerCreate$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-create';
import { vendorInquiryControllerDelete } from '../fn/vendor-inquiry/vendor-inquiry-controller-delete';
import { VendorInquiryControllerDelete$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-delete';
import { vendorInquiryControllerFindAll } from '../fn/vendor-inquiry/vendor-inquiry-controller-find-all';
import { VendorInquiryControllerFindAll$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-find-all';
import { vendorInquiryControllerFindById } from '../fn/vendor-inquiry/vendor-inquiry-controller-find-by-id';
import { VendorInquiryControllerFindById$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-find-by-id';
import { vendorInquiryControllerFindUnchecked } from '../fn/vendor-inquiry/vendor-inquiry-controller-find-unchecked';
import { VendorInquiryControllerFindUnchecked$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-find-unchecked';
import { vendorInquiryControllerRemoveAnswer } from '../fn/vendor-inquiry/vendor-inquiry-controller-remove-answer';
import { VendorInquiryControllerRemoveAnswer$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-remove-answer';
import { vendorInquiryControllerSearch } from '../fn/vendor-inquiry/vendor-inquiry-controller-search';
import { VendorInquiryControllerSearch$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-search';
import { vendorInquiryControllerUpdate } from '../fn/vendor-inquiry/vendor-inquiry-controller-update';
import { VendorInquiryControllerUpdate$Params } from '../fn/vendor-inquiry/vendor-inquiry-controller-update';
import { VendorInquiryDto } from '../models/vendor-inquiry-dto';

@Injectable({ providedIn: 'root' })
export class VendorInquiryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorInquiryControllerSearch()` */
  static readonly VendorInquiryControllerSearchPath = '/api/v1/vendorInquiry/search';

  /**
   * 1:1 문의 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerSearch$Response(params: VendorInquiryControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorInquiryControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 1:1 문의 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerSearch(params: VendorInquiryControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorInquiryControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorInquiryControllerFindAll()` */
  static readonly VendorInquiryControllerFindAllPath = '/api/v1/vendorInquiry/{id}/all';

  /**
   * 입점사 ID로 전체1:1 문의 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerFindAll$Response(params: VendorInquiryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorInquiryDto>>> {
    return vendorInquiryControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 ID로 전체1:1 문의 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerFindAll(params: VendorInquiryControllerFindAll$Params, context?: HttpContext): Observable<Array<VendorInquiryDto>> {
    return this.vendorInquiryControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorInquiryDto>>): Array<VendorInquiryDto> => r.body)
    );
  }

  /** Path part for operation `vendorInquiryControllerFindUnchecked()` */
  static readonly VendorInquiryControllerFindUncheckedPath = '/api/v1/vendorInquiry/{id}/unchecked';

  /**
   * 입점사 ID로 미답변 문의 개수 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerFindUnchecked()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerFindUnchecked$Response(params: VendorInquiryControllerFindUnchecked$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return vendorInquiryControllerFindUnchecked(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 ID로 미답변 문의 개수 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerFindUnchecked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerFindUnchecked(params: VendorInquiryControllerFindUnchecked$Params, context?: HttpContext): Observable<number> {
    return this.vendorInquiryControllerFindUnchecked$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `vendorInquiryControllerFindById()` */
  static readonly VendorInquiryControllerFindByIdPath = '/api/v1/vendorInquiry/{id}';

  /**
   * 1:1 문의 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerFindById$Response(params: VendorInquiryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInquiryDto>> {
    return vendorInquiryControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 1:1 문의 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerFindById(params: VendorInquiryControllerFindById$Params, context?: HttpContext): Observable<VendorInquiryDto> {
    return this.vendorInquiryControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorInquiryDto>): VendorInquiryDto => r.body)
    );
  }

  /** Path part for operation `vendorInquiryControllerDelete()` */
  static readonly VendorInquiryControllerDeletePath = '/api/v1/vendorInquiry/{id}';

  /**
   * 1:1 문의 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerDelete$Response(params: VendorInquiryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return vendorInquiryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 1:1 문의 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerDelete(params: VendorInquiryControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.vendorInquiryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `vendorInquiryControllerUpdate()` */
  static readonly VendorInquiryControllerUpdatePath = '/api/v1/vendorInquiry/{id}';

  /**
   * 1:1 문의 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorInquiryControllerUpdate$Response(params: VendorInquiryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInquiryDto>> {
    return vendorInquiryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 1:1 문의 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorInquiryControllerUpdate(params: VendorInquiryControllerUpdate$Params, context?: HttpContext): Observable<VendorInquiryDto> {
    return this.vendorInquiryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorInquiryDto>): VendorInquiryDto => r.body)
    );
  }

  /** Path part for operation `vendorInquiryControllerCreate()` */
  static readonly VendorInquiryControllerCreatePath = '/api/v1/vendorInquiry/{clientWorkspaceId}';

  /**
   * 1:1 문의 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorInquiryControllerCreate$Response(params: VendorInquiryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInquiryDto>> {
    return vendorInquiryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 1:1 문의 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorInquiryControllerCreate(params: VendorInquiryControllerCreate$Params, context?: HttpContext): Observable<VendorInquiryDto> {
    return this.vendorInquiryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorInquiryDto>): VendorInquiryDto => r.body)
    );
  }

  /** Path part for operation `vendorInquiryControllerAnswer()` */
  static readonly VendorInquiryControllerAnswerPath = '/api/v1/vendorInquiry/{id}/answer';

  /**
   * 1:1 문의 답변 등록 및 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerAnswer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorInquiryControllerAnswer$Response(params: VendorInquiryControllerAnswer$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInquiryDto>> {
    return vendorInquiryControllerAnswer(this.http, this.rootUrl, params, context);
  }

  /**
   * 1:1 문의 답변 등록 및 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerAnswer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorInquiryControllerAnswer(params: VendorInquiryControllerAnswer$Params, context?: HttpContext): Observable<VendorInquiryDto> {
    return this.vendorInquiryControllerAnswer$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorInquiryDto>): VendorInquiryDto => r.body)
    );
  }

  /** Path part for operation `vendorInquiryControllerRemoveAnswer()` */
  static readonly VendorInquiryControllerRemoveAnswerPath = '/api/v1/vendorInquiry/{id}/remove-answer';

  /**
   * 1:1 문의 답변 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorInquiryControllerRemoveAnswer()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerRemoveAnswer$Response(params: VendorInquiryControllerRemoveAnswer$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInquiryDto>> {
    return vendorInquiryControllerRemoveAnswer(this.http, this.rootUrl, params, context);
  }

  /**
   * 1:1 문의 답변 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorInquiryControllerRemoveAnswer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorInquiryControllerRemoveAnswer(params: VendorInquiryControllerRemoveAnswer$Params, context?: HttpContext): Observable<VendorInquiryDto> {
    return this.vendorInquiryControllerRemoveAnswer$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorInquiryDto>): VendorInquiryDto => r.body)
    );
  }

}
